module.exports = __webpack_public_path__ + "img/bg54271df7.7a4f41f3.jpg";